function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, useMemo } from "react";
import { Animated, View } from "react-native";
import { useBiblo } from "../hooks/Biblo.hook";
import { ReaderList } from "../components/reader/ReaderList.component";
import { getViewStyles } from "../helpers/getStyles.helper";
export const ReaderScreen = /*#__PURE__*/React.memo(_ref => {
  let {
    file
  } = _ref;
  const {
    files,
    selectedFile,
    readerOptions,
    disableDefaultStyles: disableDefaultStylesGlobal
  } = useBiblo();
  const showFile = useMemo(() => {
    const findFilePath = file || selectedFile;
    let foundFile = undefined;
    if (findFilePath) {
      files.find(_ref2 => {
        let {
          data
        } = _ref2;
        return data.find(currentFile => {
          if (currentFile.path === findFilePath) {
            foundFile = {
              ...currentFile
            };
          }
        });
      });
    }
    return foundFile;
  }, [files, file, selectedFile]);
  const disableDefaultStyles = disableDefaultStylesGlobal || readerOptions.disableDefaultStyles;
  const Wrapper = readerOptions.wrapperComponent || View;
  useEffect(() => {
    if (readerOptions.onMount) {
      readerOptions.onMount();
    }

    // We don't want to add readerOptions to the dependency array,
    // because that will cause onMount() to fire on every change
    // and not just on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return showFile ? /*#__PURE__*/React.createElement(Wrapper, {
    item: showFile,
    style: getViewStyles(readerOptions.wrapperStyle, {
      flex: 1
    }, disableDefaultStyles)
  }, /*#__PURE__*/React.createElement(Animated.ScrollView, _extends({
    key: selectedFile,
    keyboardDismissMode: "on-drag",
    keyboardShouldPersistTaps: "always"
  }, readerOptions.scrollViewProps), /*#__PURE__*/React.createElement(ReaderList, {
    file: showFile
  }))) : null;
});
ReaderScreen.displayName = "ReaderScreen";
//# sourceMappingURL=Reader.screen.js.map